var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnisat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115.77 147.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u672A\u547D\u540D\u7684\u6E10\u53D8_6);\n      }\n\n      .cls-2 {\n        fill: url(#_\u672A\u547D\u540D\u7684\u6E10\u53D8_5);\n      }\n\n      .cls-3 {\n        fill: url(#_\u672A\u547D\u540D\u7684\u6E10\u53D8_4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_5",
    "data-name": "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8 5",
    x1: 3379.03,
    y1: -2102,
    x2: 3415.48,
    y2: -2198.11,
    gradientTransform: "translate(3978.36 952.03) rotate(-134.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#77390d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ea8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_4",
    "data-name": "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8 4",
    x1: 3384.23,
    y1: -2231.42,
    x2: 3330.64,
    y2: -2131.29,
    gradientTransform: "translate(3978.36 952.03) rotate(-134.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#77390d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ea8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4fb52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_6",
    "data-name": "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8 6",
    cx: 53.01,
    cy: 45.84,
    fx: 53.01,
    fy: 45.84,
    r: 11.13,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4b852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ea8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#77390d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211c1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.66,13.29l30.31,30.02c2.58,2.55,3.85,5.13,3.81,7.73-.04,2.6-1.15,4.97-3.32,7.12-2.27,2.25-4.72,3.39-7.34,3.44-2.62,.04-5.22-1.22-7.8-3.77l-31-30.7c-3.52-3.49-6.92-5.96-10.19-7.41-3.27-1.45-6.71-1.68-10.31-.68-3.61,.99-7.48,3.54-11.63,7.64-5.72,5.67-8.45,10.99-8.17,15.96,.28,4.97,3.12,10.13,8.51,15.46l31.25,30.96c2.61,2.58,3.89,5.16,3.85,7.72-.04,2.57-1.16,4.94-3.37,7.13-2.2,2.18-4.63,3.32-7.27,3.41-2.64,.09-5.27-1.16-7.87-3.74l-30.31-30.02c-4.93-4.88-8.49-9.5-10.68-13.86-2.19-4.36-3.01-9.29-2.44-14.79,.51-4.71,2.02-9.27,4.54-13.69,2.51-4.42,6.11-8.94,10.78-13.57,5.56-5.51,10.87-9.73,15.93-12.67C43.99,2.04,48.88,.41,53.6,.07c4.73-.34,9.39,.6,14,2.82,4.61,2.22,9.29,5.68,14.05,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.11,134.42L3.81,104.4C1.23,101.84-.04,99.27,0,96.67c.04-2.6,1.15-4.97,3.32-7.12,2.27-2.25,4.72-3.39,7.34-3.44,2.62-.04,5.22,1.21,7.8,3.77l30.99,30.7c3.53,3.49,6.92,5.96,10.19,7.41,3.27,1.45,6.71,1.67,10.32,.68,3.61-.99,7.48-3.54,11.63-7.65,5.72-5.67,8.45-10.99,8.17-15.96-.28-4.97-3.12-10.13-8.51-15.47l-16.65-16.35c-2.61-2.58-3.89-5.16-3.85-7.72,.04-2.57,1.16-4.94,3.37-7.13,2.2-2.18,4.63-3.32,7.27-3.41,2.64-.09,5.27,1.16,7.87,3.74l15.7,15.41c4.93,4.88,8.49,9.5,10.68,13.86,2.19,4.36,3.01,9.29,2.44,14.79-.51,4.71-2.02,9.27-4.54,13.69-2.51,4.42-6.11,8.94-10.78,13.57-5.56,5.51-10.87,9.73-15.93,12.67-5.06,2.94-9.95,4.58-14.68,4.92-4.73,.34-9.39-.6-14-2.82-4.61-2.22-9.29-5.68-14.05-10.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.01,
    cy: 45.83,
    r: 11.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisat);
export default __webpack_public_path__ + "static/media/unisat.4bf6a2cbd98edbf6055afc202bbfdeae.svg";
export { ForwardRef as ReactComponent };